/* eslint-disable  */
//@ts-nocheck
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import auth from '../auth';
import mux from '../video-library/mux';
import ajax from '../ajax';
import { useQuery } from '@apollo/client';
import { GET_INFLUENCER } from '@client/api/graphql/query';
import Spinner from '../Spinner';
import { ChatApi } from '@client/api/ChatApi';
import { Typography } from '@mui/material';

const StreamBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.span`
  font-size: 14px;
  line-height: 21px;
  font-weight: bold;
  letter-spacing: 0.1em;
  color: #49536e;
`;

const Stack = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const SmallButton = styled.button`
  background: ${(props) => (props.success ? '#59d972' : '#49536e')};
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 10px;
  line-height: 15px;
  border: none;
  border-radius: 6px;
  color: #fff;
  border-radius: 3px;
  padding: 1px 5px;
  margin-left: 10px;
`;

const NeedHelpTile = styled.a`
  width: 260px;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e3e6ed;
  & > h1 {
    font-weight: bold;
    font-size: 15px;
    color: #151e34;
    margin: 0;
    margin-bottom: 7px;
  }
  & > h2 {
    color: #6367ef;
    font-weight: 700;
    letter-spacing: 1px;
    font-size: 10px;
    margin: 0;
  }
`;

const StreamKey = styled.div`
  display: flex;
  align-items: center;
`;

const StreamKeyInput = styled.input`
  width: 100%;
  height: auto;
  font-size: 18px;
  padding: 18px 30px !important;
  background: #fff;
  border: 1px solid #e3e6ed !important;
  border-radius: 8px;
  margin-right: 20px !important;
  ::placeholder {
    color: palevioletred;
  }
`;

const Button = styled.button`
  background: #6367ef;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  border: none;
  color: #fff;
  border-radius: 6px;
  padding: 9px 14px;
`;

export const SetupTab = ({ influencerId }: { influencerId: number }) => {
  const [streamToken, setStreamToken] = useState(null);
  const [keyCopied, setKeyCopied] = useState(false);
  const [liveStreamKey, setLiveStreamKey] = useState(null);
  const [generatingStreamKey, setGeneratingStreamKey] = useState(false);

  const resetKey = useCallback(async () => {
    setGeneratingStreamKey(true);
    const {
      data: { stream_key },
    } = await mux.generateStreamKey({
      influencerId,
    });

    const prepareInfluencer = (i) => {
      if (!i.index || isNaN(i.index)) {
        i.index = 0;
      } else {
        i.index = parseInt(i.index);
      }
      return i;
    };

    const influencer = await ajax.getInfluencers(influencerId);
    influencer.liveStreamKey = stream_key;
    const preparedInfluencer = prepareInfluencer(influencer);
    await ajax.upsertInfluencer(preparedInfluencer);

    setLiveStreamKey(stream_key);
    setGeneratingStreamKey(false);
  }, [influencerId]);

  const isModerator = influencerId > 0;

  useEffect(() => {
    const getStreamToken = async () => {
      const token = isModerator
        ? await ChatApi.getModeratorChatToken({ creatorId: influencerId })
        : await ChatApi.getCreatorChatToken();
      setStreamToken(token);
    };

    (() => getStreamToken())();
  }, []);

  const { loading, error, data } = useQuery(GET_INFLUENCER, {
    variables: { id: influencerId },
    skip: !influencerId,
  });

  useEffect(() => {
    if (data) {
      setLiveStreamKey(data.creator.liveStreamKey);
    }
  }, [data]);

  if (!influencerId || loading) {
    return (
      <div className="p-5 md:p-10">
        <span>Loading...</span>
        <div className="row">
          <Spinner
            color={`#6367ef`}
            style={{ margin: 'auto', marginTop: '5px' }}
          />
        </div>
      </div>
    );
  }
  if (error) {
    return <span>Unknown error. Try again later</span>;
  }

  return (
    <>
      <StreamBox>
        <Stack>
          <Title>STREAM KEY</Title>
          <SmallButton
            onClick={() => {
              navigator.clipboard.writeText(liveStreamKey);
              setKeyCopied(true);
              setTimeout(() => setKeyCopied(false), 3000);
            }}
            success={keyCopied}
          >
            {keyCopied ? 'COPIED!' : 'COPY'}
          </SmallButton>
        </Stack>
        {generatingStreamKey ? (
          <div className="row">
            <Spinner
              color={`#6367ef`}
              style={{ margin: 'auto', marginTop: '5px' }}
            />
          </div>
        ) : (
          <StreamKey>
            <StreamKeyInput type="text" value={liveStreamKey ?? ''} readOnly />
            <Button onClick={resetKey}>
              {liveStreamKey ? 'Reset' : 'Generate'}
            </Button>
          </StreamKey>
        )}
      </StreamBox>

      <div className="pt-[40px]">
        <Stack>
          <Title>NEED HELP?</Title>
        </Stack>
        <div className="flex space-x-[15px]">
          <NeedHelpTile
            href="https://help.playbookapp.io/en/articles/11014431-how-to-livestream"
            target="_blank"
          >
            <Typography variant="h1">How to set up LiveStream</Typography>
            <h2>VISIT ARTICLE</h2>
          </NeedHelpTile>
        </div>
      </div>
    </>
  );
};
